export default {
  canvas: (state) => state.canvas,
  currentState: (state) => state.history.currentState,
  historyStack: (state) => state.history.stack,
  redoStack: (state) => state.history.redoStack,
  maxStackLength: (state) => state.history.maxStackLength,
  isHistoryLocked: (state) => state.history.isLocked,
}